import { useState } from 'react';
import { useScraperHistory } from '../../../api/queries';
import { Empty } from '../../../components/Empty';
import { Ic } from '../../../components/Ic';
import { dateTime, formatDuration } from '../../../lib/time';

/** Replaces the error-history section of the old debug page. */
export function HistoryTab({ name }: { name: string }) {
  const { data: history, isLoading } = useScraperHistory(name);
  const [expanded, setExpanded] = useState<number | null>(null);

  if (isLoading) return <div className="muted">Loading history…</div>;
  if (!history?.length) {
    return <Empty icon={Ic.history} title="No runs recorded" detail="History appears after the first run." />;
  }

  return (
    <div className="pcard">
      <div className="tbl-scroll">
        <table className="tbl">
          <thead>
            <tr>
              <th>When</th>
              <th>Status</th>
              <th>Duration</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            {history.map((run, i) => {
              const failed = run.status === 'error';
              const isOpen = expanded === i;
              return (
                <tr
                  key={`${run.ts}-${i}`}
                  onClick={() => setExpanded(isOpen ? null : i)}
                  style={{ cursor: run.output || run.error ? 'pointer' : 'default' }}
                >
                  <td className="mono-sm">{dateTime(run.ts)}</td>
                  <td>
                    <span className={`pill ${failed ? 'red' : 'green'}`}>{run.status}</span>
                  </td>
                  <td className="mono-sm">{formatDuration(run.exec_time)}</td>
                  <td style={{ maxWidth: 380 }}>
                    {run.error_type && (
                      <span className="pill red" style={{ marginRight: 6 }}>
                        {run.error_type}
                      </span>
                    )}
                    {isOpen ? (
                      <pre
                        className="mono-sm"
                        style={{ whiteSpace: 'pre-wrap', margin: 0, color: 'var(--fg-2)' }}
                      >
                        {run.error ?? run.output ?? '—'}
                      </pre>
                    ) : (
                      <span className="mono-sm">
                        {(run.error ?? run.output ?? '—').split('\n')[0]?.slice(0, 80) ?? '—'}
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
